import { comparisonItems as items, getMergedItem, getValue } from "../../master"
import * as React from "react"
import { ComparisonListItem } from "../ComparisonList/ComparisonListItem"
import { ProductDetail } from "./ProductDetail"
import { ComparisonList } from "../ComparisonList/ComparisonList"
import { ProductSpec } from "../../master/interface"

type ProductProps = {
  product: ProductSpec
}

export const Product: React.FC<ProductProps> = ({ product }) => {
  return (
    <div className="min-w-4/5 lg:min-w-0 flex-1">
      <ProductDetail
        id={product.id}
        name={product.name}
        capacity={product.capacity}
        colors={product.colors}
        defaultColor={product.defaultColor}
        price={product.price}
        salePrice={product.salePrice}
        description={product.description}
        url={product.url}
      />
      <ComparisonList>
        {items.map(item => {
          const value = getValue(product[item.id])
          const mergedItem = getMergedItem(item, product[item.id])

          return (
            <ComparisonListItem
              key={item.id}
              item={mergedItem}
              value={value}
            />
          )
        })}
      </ComparisonList>
    </div>
  )
}
